import React from "react";
import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import styled from "styled-components/macro";
import { ReactComponent as Warning } from "../../svgs/warning.svg";

const SaveButton = styled.button`
  border-radius:10px;
  background: linear-gradient(to bottom, #005AA9D9, #005AA9);
  width: 132px;
  height: 37px;
  color: #FFFFFF;
  border-bottom: 1px solid #004989;
  cursor: pointer;

  &[disabled] {
    background: #b4b4b4;
    border-bottom: 1px solid #b4b4b4;
    cursor: initial;
  }
`;

const DiscardButton = styled.button`
  border-radius:10px;
  background: #F7F7F7;
  width:132px;
  height: 37px;
  border: 1px solid #E1E1E1;
  color: #005AA9;
  cursor: pointer;
  margin-left:37px;
  margin-right:20px;
  border-width: 0.5px 0.5px 1px 0.5px;
`;

const StyledDialog = styled(Dialog)`
  box-shadow: 0px 4px 8px 0px #00000040;
  border: 1px solid #DADCE0;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  z-index: 1300 !important;
  position: fixed !important;
  pointer-events: all !important;
`;

const StyledDialogContent = styled(DialogContent)`
  width: 357px;
`;

const WaitText = styled.p`
  font-family: 'Metropolis';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: rgba(16, 47, 84, 0.8);
  margin-bottom:12px;
  margin-top:20px;
`;

const DialogText = styled.p`
  font-family: 'Metropolis';
  font-size: 20px;
  text-align: center;
  color: #102F54B2;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
`;

const WarningIcon = styled(Warning)`
  margin: 0 auto;
  color: #005AA9;
  position: relative;
  right: -22px;
`;

const WarningIconContainers = styled.div`
  display: flex;
`;

const StyledCloseIcon = styled(CloseIcon)`
  color: #C40A0A;
`;

const StyledIconButton = styled(IconButton)`
  position: relative;
  top: -23px;
`;

const UserConfirmationModal = ({ onConfirmClick, onCancelClick, onClose, open, discardText, saveText, isDisabled }) => {
  return (
    <StyledDialog modal maxWidth="md" open={open} autoDetectWindowHeight autoScrollBodyContent>
      <StyledDialogContent>
        <WarningIconContainers>
          <WarningIcon />
          <StyledIconButton onClick={onClose}>
            <StyledCloseIcon />
          </StyledIconButton>
        </WarningIconContainers>
        <WaitText>Wait!</WaitText>
        <DialogText>You have unsaved changes. Do you want to save your changes?</DialogText>
        <DiscardButton onClick={onCancelClick}>{discardText || "Discard"}</DiscardButton>
        <SaveButton onClick={onConfirmClick} disabled={isDisabled || false}>
          {saveText || "Save"}
        </SaveButton>
      </StyledDialogContent>
    </StyledDialog>
  );
};

export default UserConfirmationModal;
